module.exports = __webpack_public_path__ + "img/img24.2f6f29d8.svg";